import { GENDER_TYPE } from '../enums/Gender';

export const TYPES: string[] = [
    GENDER_TYPE.FEMALE,
    GENDER_TYPE.MALE,
    GENDER_TYPE.HIDDEN,
];
